import { developmentEnvironment } from './development'
import { localhostEnvironment } from './localhost'
import { productionEnvironment } from './production'
import { Environment } from './types'

/**
 * Get the current environment configuration based on VITE_APP_ENV
 */
export const getEnvironment = (): Environment => {
	const mode =
		import.meta.env.VITE_APP_ENV || import.meta.env.MODE || 'development'

	switch (mode) {
		case 'localhost':
			return localhostEnvironment
		case 'development':
			return developmentEnvironment
		case 'production':
			return productionEnvironment
		default:
			console.warn(`Unknown environment: ${mode}, falling back to development`)
			return developmentEnvironment
	}
}

// Export a singleton instance of the environment
export const env = getEnvironment()

// Type-safe helper to access environment variables
export const getEnvVar = <K extends keyof Environment>(
	key: K
): Environment[K] => {
	return env[key]
}

// Export types
export type { Environment }
export { localhostEnvironment, developmentEnvironment, productionEnvironment }
